import { useState } from 'react';
import { BACKEND_URL } from "../data/config";

const UploadModal = ({ isOpen, onClose }) => {
  const [dragActive, setDragActive] = useState(false);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') {
      setDragActive(true);
    } else if (e.type === 'dragleave') {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && (droppedFile.name.endsWith('.csv') || droppedFile.name.endsWith('.xlsx'))) {
      setFile(droppedFile);
      setMessage('');
    } else {
      setMessage('Veuillez sélectionner un fichier CSV ou Excel');
    }
  };

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && (selectedFile.name.endsWith('.csv') || selectedFile.name.endsWith('.xlsx'))) {
      setFile(selectedFile);
      setMessage('');
    } else {
      setMessage('Veuillez sélectionner un fichier CSV ou Excel');
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage('Veuillez sélectionner un fichier');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setUploading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/api/upload-attendance.php?token=ycpSjvmEVdyb8VbUJ6`, {
        method: 'POST',
        body: formData,
      });

      const result = await response.json();
      if (result.success) {
        setMessage('✅ Fichier traité avec succès ! ' + result.stats?.summary);
        setFile(null);
      } else {
        setMessage('❌ Erreur: ' + result.message);
      }
    } catch (error) {
      setMessage('❌ Erreur de connexion');
    } finally {
      setUploading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Upload Pointage</h2>
          
          <div className="space-y-4">
            <div
              className={`border-2 border-dashed rounded-xl p-8 text-center transition-all duration-200 cursor-pointer hover:shadow-lg ${
                dragActive
                  ? 'border-blue-300 bg-blue-50 shadow-lg'
                  : 'border-gray-200 hover:border-blue-200'
              }`}
              onDragEnter={handleDrag}
              onDragLeave={handleDrag}
              onDragOver={handleDrag}
              onDrop={handleDrop}
            >
              <svg className="w-16 h-16 mx-auto mb-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
              </svg>
              <p className="text-lg font-semibold text-gray-700 mb-1">
                {dragActive ? 'Déposez le fichier' : 'Glissez-déposez ou cliquez'}
              </p>
              <p className="text-sm text-gray-500 mb-4">CSV ou Excel (.csv, .xlsx)</p>
              <input
                type="file"
                accept=".csv,.xlsx"
                onChange={handleFileSelect}
                className="hidden"
                id="file-upload"
              />
              <label htmlFor="file-upload" className="bg-blue-100 hover:bg-blue-200 text-blue-700 font-medium py-2 px-6 rounded-xl text-sm cursor-pointer inline-block transition-colors">
                Parcourir fichiers
              </label>
            </div>

            {file && (
              <div className="p-4 bg-green-50 border border-green-200 rounded-xl">
                <div className="flex items-center justify-between">
                  <span className="font-medium text-green-800">{file.name}</span>
                  <button
                    onClick={() => setFile(null)}
                    className="text-green-600 hover:text-green-800 font-medium text-sm"
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            )}

            {message && (
              <div className={`p-4 rounded-xl text-sm ${
                message.startsWith('✅') ? 'bg-green-50 border border-green-200 text-green-800' : 'bg-red-50 border border-red-200 text-red-800'
              }`}>
                {message}
              </div>
            )}

            <div className="flex gap-3 pt-4">
              <button
                onClick={handleUpload}
                disabled={!file || uploading}
                className="flex-1 bg-blue-100 hover:bg-blue-200 text-blue-700 font-semibold py-3 px-4 rounded-xl text-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow-md"
              >
                {uploading ? 'Traitement...' : 'Traiter fichier'}
              </button>
              <button
                onClick={onClose}
                className="px-6 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 rounded-xl text-sm transition-all duration-200 shadow-sm hover:shadow-md"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadModal;
